/**
 *
 * @author Iecisa
 */
export class ConfirmSmsRegisterDTO {
    code: string;
    number: string;
}
